import ApiService from './api.service'

const GrupoService = {
    listGrupos: async function() {
      try {
        const response = await ApiService.get('/grupos/listing')
        return response
      } catch (error) {
        throw error
      }
    },
}

export default GrupoService